import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { iconExists } from '@grandvisionhq/icons';
import { parseLink } from '@grandvisionhq/state';
import { parseHtml, DateUtils } from '@grandvisionhq/utils';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import { isWithinTimeSpan } from '../../utils/datetime.js';
import CampaignInfoBanner$1 from './CampaignInfoBanner.js';

const CampaignInfoBannerContainer = (_param)=>{
    var { startEndDateCompound , bannerIcon , bannerTitle  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "startEndDateCompound",
        "bannerIcon",
        "bannerTitle"
    ]);
    const [, { routerId , currentRoute  }] = useRoutingContext();
    const text = React.useMemo(()=>bannerTitle && parseHtml(parseLink(bannerTitle, true))
    , [
        bannerTitle
    ]);
    const showBanner = React.useMemo(()=>{
        if (routerId !== 'book-appointment' || ![
            '',
            'where',
            'what',
            'when',
            'who'
        ].includes(currentRoute) || !text || !(startEndDateCompound === null || startEndDateCompound === void 0 ? void 0 : startEndDateCompound.startDate) || !(startEndDateCompound === null || startEndDateCompound === void 0 ? void 0 : startEndDateCompound.endDate)) {
            return false;
        }
        const currentTime = new Date();
        const startDate = new Date(startEndDateCompound.startDate);
        const endDate = new Date(startEndDateCompound.endDate);
        // The Bloomreach UI unfortunately does not check for a valid date range.
        // We need to perform an extra check to ensure the AAB pages do not break.
        if (!DateUtils.isValidDateRange(startDate, endDate)) {
            return false;
        }
        return isWithinTimeSpan(currentTime, startDate, endDate);
    }, [
        startEndDateCompound,
        text,
        routerId,
        currentRoute
    ]);
    const displayIcon = React.useMemo(()=>bannerIcon && iconExists(bannerIcon)
    , [
        bannerIcon
    ]);
    if (showBanner === false || !text) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(CampaignInfoBanner$1, swcHelpers.extends({
        icon: displayIcon ? bannerIcon : undefined,
        text: text
    }, rest));
};
var CampaignInfoBanner = CampaignInfoBannerContainer;

export { CampaignInfoBanner as default };
//# sourceMappingURL=CampaignInfoBannerContainer.js.map
